import React, { useContext, useEffect } from "react";
import IWalletForm from "./IWalletForm";
import { Form } from "antd";
import InfoBox from "@appComponents/InfoBox/InfoBox";
import { dropdownSelectRef } from "@appComponents/Dropdown/Dropdown";
import { MAIN_CURRENCY } from "@bundles/consts";
import { FundsDispatchContext } from "@features/context";
import { checkAddress } from "@features/utils/functions";
import FormInput from "../FormInput";
import FormSelect from "../FormSelect";

import * as style from "./WalletFormStyle.module.scss";
const stableCoinCurrenciesSelectOptions = [
  {
    value: "usdt",
    label: "USDT Ethereum (ERC-20)",
  },
];
export const selectWalletTypeOptions = [
  {
    value: "erc20",
    label: "Ethereum",
  },
];

const WalletForm: React.FunctionComponent<IWalletForm> = (
  props: IWalletForm
) => {
  const dispatch = useContext(FundsDispatchContext);

  useEffect(() => {
    if (dropdownSelectRef && dropdownSelectRef.current) {
      dropdownSelectRef.current.disabled = true;
    }
    return () => {
      if (dropdownSelectRef && dropdownSelectRef.current) {
        dropdownSelectRef.current.disabled = false;
      }
    };
  }, []);

  const walletAddressWarning = (value: string | undefined) => {
    if (!value) {
      return undefined;
    }

    const { currency, values } = props;
    const usdWalletType =
      values.usd_wallet_type && currency === MAIN_CURRENCY
        ? values.usd_wallet_type.value
        : undefined;

    return checkAddress(value, currency, usdWalletType);
  };

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    isWalletAddressField?: boolean
  ) => {
    const { value, name } = e.target;
    let errors;

    if (isWalletAddressField) {
      errors = walletAddressWarning(value);
    } else {
      errors = walletAddressWarning(props.values.address);
    }

    dispatch({
      type: "edit",
      payload: {
        value,
        name,
        addressRegex: props.addressRegex,
        errors,
      },
    });
  };

  const onCurrencySelectChange = (value: { value: string; label: string }) => {
    dispatch({
      type: "edit",
      payload: {
        value,
        name: "currency",
        errors: walletAddressWarning(props.values.address),
      },
    });
  };

  const onWalletCurrencySelectChange = (value: {
    value: string;
    label: string;
  }) => {
    dispatch({
      type: "edit",
      payload: { value, name: "bfusd_wallet_currency" },
      relatedData: [
        {
          name: "selectedWalletCurrency",
          value: value.value,
        },
      ],
      errors: walletAddressWarning(props.values.address),
    });
  };

  useEffect(() => {
    if (props.currency === MAIN_CURRENCY) {
      onWalletCurrencySelectChange(stableCoinCurrenciesSelectOptions[0]);
    }
  }, [props.currency]);

  return (
    <Form className={style.walletForm}>
      <h3 className={style.headline}>
        {props.currencies ? "Edit" : "Add New"} Crypto Wallet
      </h3>
      {props.currencies && (
        <FormSelect
          selectProps={{
            onChange: (selectedValue) =>
              onCurrencySelectChange({
                value: selectedValue,
                label: props.currencies?.find(
                  (currency) => currency.value === selectedValue
                )?.label!,
              }),
            defaultValue: props.currencies.find(
              (el) => el.value === props.currency
            )?.value,
            options: props.currencies,
            style: { width: "100%" },
          }}
          formItemProps={{
            label: "Currency",
          }}
        />
      )}
      <FormInput
        formItemProps={{
          label: "Wallet name",
          name: "name",
          help: props.values.name !== undefined ? props.errors.name : "",
        }}
        inputProps={{
          onChange: (e) => onChange(e, false),
          defaultValue: props.values.name || "",
          name: "name",
        }}
      />
      {props.currency === MAIN_CURRENCY && (
        <FormSelect
          selectProps={{
            onChange: () =>
              onWalletCurrencySelectChange({
                ...stableCoinCurrenciesSelectOptions[0],
              }),
            defaultValue: stableCoinCurrenciesSelectOptions[0],
            options: stableCoinCurrenciesSelectOptions,
            style: { width: "100%" },
            disabled: true,
          }}
          formItemProps={{ label: "Wallet Currency" }}
        />
      )}

      <FormInput
        formItemProps={{
          label: "Wallet address",
          name: "address",
          help: props.values.address !== undefined ? props.errors.address : "",
        }}
        inputProps={{
          onChange: (e) => onChange(e, true),
          defaultValue: props.values.address || "",
          name: "address",
          disabled: !Boolean(props.currency),
        }}
      />

      {walletAddressWarning(props.values.address) && (
        <InfoBox>
          <p className={style.info}>
            {walletAddressWarning(props.values.address)}
          </p>
        </InfoBox>
      )}
    </Form>
  );
};

export default WalletForm;
